import { useEffect, useState } from 'react';

import { Timestamp } from '@components/primitives/Timestamp';

import { ago } from '@utils/ago';

export interface AgoProps {
  className?: string;
  value: string | number | Date;
  lowerCase?: boolean;
  alwaysShowYear?: boolean;
  side?: 'top' | 'bottom' | 'left' | 'right';
  align?: 'start' | 'center' | 'end';
  tooltip?: 'none' | 'simple' | 'detailed';
  delay?: number;
}

export function Ago({ value, lowerCase, alwaysShowYear, ...props }: AgoProps) {
  const [now, setNow] = useState(Date.now());

  useEffect(() => {
    const interval = setInterval(() => {
      setNow(Date.now());
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <Timestamp
      value={value}
      format={(value) => ago(value, { lowerCase, now, alwaysShowYear })}
      {...props}
    />
  );
}
